// API kökü — TEK KAYNAK.
//
// Sıra: runtime yapılandırma (public/runtime-config.js → window.__TZ_CONFIG__.apiBase)
//       > build-time REACT_APP_ADDRESS.
//
// Neden runtime katmanı var: CRA REACT_APP_* değerlerini BUILD anında gömer.
// Cloudflare Pages'te bu sorun değil (her ortam kendi build'ini alır), ama kendi
// sunucumuzda barındırılan dağıtımlarda (Holideus RU) aynı imajın farklı API
// adresiyle çalışması gerekiyor. runtime-config.js konteyner başlangıcında
// $API_BASE'ten üretilir.
//
// runtime-config.js boşsa (CF Pages / local dev) davranış değişmez.
const runtime = (typeof window !== 'undefined' && window.__TZ_CONFIG__) || {};

export const API_BASE = String(runtime.apiBase || process.env.REACT_APP_ADDRESS || '').replace(/\/+$/, '');

// reCAPTCHA site anahtarı. Google anahtarları ALAN ADI KISITLI — panel farklı bir host'tan
// (Holideus, IP ile erişim, yerel prova) servis edildiğinde build'e gömülü anahtar doğrulanmaz.
//
// ARTIK TEK KAYNAK DEĞİL: sağlayıcı seçimi (Google / Yandex SmartCaptcha) ve istemci
// anahtarı `Libs/Captcha/captchaConfig.js`'te çözülüyor. Bu dışa aktarım yalnız geriye
// dönük uyumluluk için duruyor — yeni kod captchaConfig'i kullanmalı.
export const RECAPTCHA_SITE_KEY = String(runtime.recaptchaSiteKey || process.env.REACT_APP_RECAPTCHA || '');

// Dağıtımın varsayılan dili ve para birimi (Holideus RU → ru / RUB).
// AYNI imaj farklı pazarlarda çalışıyor: hangi dille açılacağı build'e gömülemez.
// Boşsa bugünkü değerler geçerli → TourZone etkilenmez.
// Kullanıcının AÇIK seçimi (localStorage) her ikisini de ezer.
export const DEFAULT_LANG = String(runtime.defaultLang || '').toLowerCase();
export const DEFAULT_CURRENCY = String(runtime.defaultCurrency || '').toUpperCase() || 'EUR';

export const baseURLs = {
  User:  API_BASE,
  Admin: API_BASE,
};
